import RadioButtonChecked from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUnchecked from "@mui/icons-material/RadioButtonUnchecked";
import WebRounded from "@mui/icons-material/WebRounded";
import { Tooltip } from "@mui/material";
import { useState } from "react";
import { ConditionalWrapper } from "../../../../generic/components/conditional-wrapper";
import { ToolbarDropDown } from "./toolbar-drop-down";
import { ToolbarIconButton } from "./toolbar-icon-button";

import type { EmailDesign } from "../../../../email-design/server/supabase-email-design-service";
import type { ToolbarProps } from "./props";
import type { FC } from "react";

export const EmailTemplateSelector: FC<
  ToolbarProps & {
    emailDesigns: EmailDesign[];
    selectedEmailDesign: EmailDesign | undefined;
    setEmailDesign: (ed: EmailDesign | undefined) => void;
    isDirty?: boolean;
  }
> = ({ disabled, emailDesigns, selectedEmailDesign, setEmailDesign, isDirty, mode }) => {
  const [open, setOpen] = useState(false);

  if (emailDesigns.length < 2) {
    return null;
  }

  return (
    <ConditionalWrapper
      condition={isDirty}
      wrapper={(children) => (
        <Tooltip title="Save your changes to change templates.">
          <span>{children}</span>
        </Tooltip>
      )}
    >
      <ToolbarDropDown
        data-analytics-id="lexical-toolbar-dropdown-template-selector"
        disabled={disabled || isDirty}
        icon={<WebRounded />}
        heading="Template"
        open={open}
        setOpen={setOpen}
        mode={mode}
      >
        {emailDesigns.map((template) => (
          <ToolbarIconButton
            data-analytics-id={`lexical-toolbar-email-template-${template.name}`}
            key={template.id}
            icon={
              selectedEmailDesign?.id === template.id ? (
                <RadioButtonChecked />
              ) : (
                <RadioButtonUnchecked />
              )
            }
            label={template.name}
            onClick={() => {
              setEmailDesign(template);
            }}
          />
        ))}
      </ToolbarDropDown>
    </ConditionalWrapper>
  );
};
